import "@fontsource-variable/cormorant-garamond/index.css";
import "@fontsource-variable/montserrat/index.css";
import "./styles.css";
import { renderAdmin } from "./admin.js";
import { escapeHtml } from "./lib/format.js";
import { analyticsConsent, initializeTracking, setAnalyticsConsent } from "./lib/tracking.js";
import { renderStorefront } from "./storefront.js";
import { initializeLanguage } from "./lib/locale.js";

initializeTracking();
if (analyticsConsent() === "granted") rememberCampaignSource();
window.addEventListener("ko-analytics-consent-changed", () => {
  initializeTracking();
  if (analyticsConsent() === "granted") rememberCampaignSource();
  mountAnalyticsConsent();
});

const path = normalizePath(window.location.pathname);
try {
  if (path.startsWith("/admin")) await renderAdmin(path);
  else await renderStorefront(path);
} catch {
  document.querySelector("#app").innerHTML = `<main class="fatal-error"><p class="eyebrow">KVITKOVA OAZA</p><h1>Не вдалося завантажити сторінку</h1><p>Перевірте з'єднання та оновіть сторінку. Кошик збережено на цьому пристрої.</p><a class="button button-primary" href="/">На головну</a></main>`;
}

attachNavigation();
document.addEventListener("click", (event) => {
  if (event.target.closest('[data-action="analytics-settings"]')) mountAnalyticsConsent(true);
});
if (!path.startsWith("/admin")) mountAnalyticsConsent();
if (!path.startsWith("/admin")) initializeLanguage();

function rememberCampaignSource() {
  if (window.__KVITKOVA_TRACKING__?.environment !== "production") {
    localStorage.removeItem("ko-attribution-source");
    return;
  }
  const params = new URLSearchParams(window.location.search);
  const values = {};
  for (const key of ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid", "gbraid", "wbraid", "fbclid"]) {
    const value = params.get(key);
    if (value) values[key] = value.replace(/[^\p{L}\p{N} ._:/+-]/gu, "").slice(0, 256);
  }
  if (!values.utm_source && values.gclid) values.utm_source = "google_ads";
  if (!values.utm_source && values.fbclid) values.utm_source = "meta";
  if (Object.keys(values).length && !["localhost", "127.0.0.1", "::1"].includes(location.hostname)) {
    values.capturedAt = new Date().toISOString();
    localStorage.setItem("ko-attribution-source", JSON.stringify(values).slice(0, 2000));
  } else {
    try {
      const stored = JSON.parse(localStorage.getItem("ko-attribution-source") || "null");
      if (!stored?.capturedAt || Date.now() - Date.parse(stored.capturedAt) > 30 * 86400_000) localStorage.removeItem("ko-attribution-source");
    } catch { localStorage.removeItem("ko-attribution-source"); }
  }
}

function mountAnalyticsConsent(force = false) {
  document.querySelector("#analytics-consent")?.remove();
  if (["localhost", "127.0.0.1", "::1"].includes(location.hostname) || !force) return;
  const panel = document.createElement("aside");
  panel.id = "analytics-consent";
  panel.className = "analytics-consent";
  panel.setAttribute("aria-label", "Налаштування аналітики");
  panel.innerHTML = `<div><strong>Налаштування аналітики</strong><p>Необов'язкова аналітика допомагає вимірювати перегляди, заявки та ефективність реклами. Вона не потрібна для замовлення.</p></div><div class="analytics-consent-actions"><button class="button button-secondary" type="button" data-consent="denied">Відхилити</button><button class="button button-primary" type="button" data-consent="granted">Дозволити аналітику</button></div>`;
  panel.addEventListener("click", (event) => {
    const choice = event.target.closest("[data-consent]")?.dataset.consent;
    if (choice) setAnalyticsConsent(choice);
  });
  document.body.append(panel);
}

function normalizePath(value) {
  if (value.length > 1 && value.endsWith("/")) return value.slice(0, -1);
  return value;
}

function attachNavigation() {
  const searchToggle = document.querySelector('[data-action="toggle-search"]');
  searchToggle?.addEventListener("click", () => {
    const expanded = searchToggle.getAttribute("aria-expanded") !== "true";
    searchToggle.setAttribute("aria-expanded", String(expanded));
    document.querySelector(".site-header")?.classList.toggle("is-search-open", expanded);
    if (expanded) document.querySelector("#site-search")?.focus();
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && event.target.closest(".header-search")) {
      document.querySelector(".site-header")?.classList.remove("is-search-open");
      searchToggle?.setAttribute("aria-expanded", "false");
      searchToggle?.focus();
    }
  });
  const toggle = document.querySelector(".menu-toggle");
  const nav = document.querySelector("#primary-navigation");
  if (!toggle || !nav) return;
  toggle.addEventListener("click", () => {
    const expanded = toggle.getAttribute("aria-expanded") === "true";
    toggle.setAttribute("aria-expanded", String(!expanded));
    toggle.setAttribute("aria-label", expanded ? "Відкрити меню" : "Закрити меню");
    nav.classList.toggle("is-open", !expanded);
    if (expanded) toggle.focus();
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && toggle.getAttribute("aria-expanded") === "true") {
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-label", "Відкрити меню");
      nav.classList.remove("is-open");
      toggle.focus();
    }
  });
  document.addEventListener("click", (event) => {
    if (toggle.getAttribute("aria-expanded") !== "true" || nav.contains(event.target) || toggle.contains(event.target)) return;
    toggle.setAttribute("aria-expanded", "false");
    toggle.setAttribute("aria-label", "Відкрити меню");
    nav.classList.remove("is-open");
  });
}

window.addEventListener("error", (event) => {
  if (event.target instanceof HTMLImageElement) {
    event.target.closest(".product-media")?.classList.add("media-failed");
    event.target.alt = event.target.alt || "Фото тимчасово недоступне";
  }
}, true);

export { escapeHtml };
